import React from 'react';

const topRowLogos = [
  '/assets/images/logo-des/logo (1).jpg',
  '/assets/images/logo-des/logo (2).jpg',
  '/assets/images/logo-des/logo (3).jpg',
  '/assets/images/logo-des/logo (4).jpg',
  '/assets/images/logo-des/logo (5).jpg',
  '/assets/images/logo-des/logo (6).jpg',
  '/assets/images/logo-des/logo (7).jpg',
  '/assets/images/logo-des/logo (8).jpg'
];

const bottomRowLogos = [
  '/assets/images/logo-des/logo (9).jpg',
  '/assets/images/logo-des/logo (10).jpg',
  '/assets/images/logo-des/logo (11).jpg',
  '/assets/images/logo-des/logo (12).jpg',
  '/assets/images/logo-des/logo (13).jpg',
  '/assets/images/logo-des/logo (14).jpg',
  '/assets/images/logo-des/logo (15).jpg',
  '/assets/images/logo-des/logo (16).jpg'
];

function LogoPortfolioSlider() {
  // Duplicate arrays to create continuous infinite seamless loop
  const topLoop = [...topRowLogos, ...topRowLogos, ...topRowLogos];
  const bottomLoop = [...bottomRowLogos, ...bottomRowLogos, ...bottomRowLogos];

  return (
    <section className="logo-portfolio-section">
      <div className="container">
        {/* Section Heading */}
        <h2 className="logo-portfolio-title">
          Portfolio For the <span className="text-red">Best Logo Design Services</span>
        </h2>
      </div>

      <div className="logo-portfolio-slider-wrapper">
        {/* Top Row: Auto-slide Left */}
        <div className="logo-portfolio-row">
          <div className="logo-portfolio-track track-slide-left">
            {topLoop.map((logoSrc, index) => (
              <div key={`top-${index}`} className="logo-portfolio-card">
                <img 
                  src={logoSrc} 
                  alt={`Logo Design Portfolio Showcase ${index + 1}`} 
                  className="logo-portfolio-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>

        {/* Bottom Row: Auto-slide Right */}
        <div className="logo-portfolio-row">
          <div className="logo-portfolio-track track-slide-right">
            {bottomLoop.map((logoSrc, index) => (
              <div key={`bottom-${index}`} className="logo-portfolio-card">
                <img 
                  src={logoSrc} 
                  alt={`Logo Design Portfolio Showcase ${index + 1}`} 
                  className="logo-portfolio-img"
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default LogoPortfolioSlider;
